import type { IDevice } from '~/types/store/device';
import { wrapPiniaStore } from '@devhacker/shared/utils/wrapPiniaStore';
import { defineStore } from 'pinia';

export const useDeviceStore = wrapPiniaStore(
  defineStore('device', {
    state: () => ({
      device: {
        isMobile: false,
        isTablet: false,
        isDesktop: false,
      },
    }),

    getters: {
      isMobile: (state) => state.device.isMobile,
      isTablet: (state) => state.device.isTablet,
      isDesktop: (state) => state.device.isDesktop,
      deviceType: (state) => {
        if (state.device.isMobile) return 'mobile';
        if (state.device.isTablet) return 'tablet';
        if (state.device.isDesktop) return 'desktop';
        return 'unknown';
      },
    },

    actions: {
      setDevice(device: IDevice) {
        this.device = device;
      },
    },
  }),
);
